/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import * as React from 'react';
import { Stack, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material/index.js';
import { isMobile } from 'react-device-detect';
import toast from '../SnackBar/toast.js';

var AlertDialog = function (props) {
    var _a = React.useState(!!props.openedDialog), open = _a[0], setOpen = _a[1];
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    var dialogWidth = isMobile ? "xl" : "sm";
    return (React.createElement("div", null,
        React.createElement(Stack, { direction: "row", justifyContent: "center", alignItems: "center", spacing: 1 },
            props.message.length > 0 && React.createElement(Button, { color: "inherit", onClick: handleClickOpen }, "Details"),
            React.createElement(Button, { color: "inherit", onClick: function () { return toast.close(props.key); } }, "Dismiss")),
        React.createElement(Dialog, { fullWidth: true, maxWidth: dialogWidth, open: open, onClose: handleClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
            React.createElement(DialogTitle, { id: "alert-dialog-title" }, "Error details"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: "alert-dialog-description" }, props.message),
                props.handleRequestPermissions &&
                    React.createElement(DialogActions, null,
                        React.createElement(Button, { variant: 'outlined', onClick: props.handleRequestPermissions }, "Request Permissions"))))));
};
var AlertDialog$1 = AlertDialog;

export { AlertDialog$1 as default };
